module.exports = __webpack_public_path__ + "static/croccha_ttl-63463db4477dc129c6fe8a605be394c7.svg";